/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Role_3Inputs */

const en_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing specialist`)
};

const de_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing-Spezialistin`)
};

const fr_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécialiste marketing`)
};

const es_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especialista en marketing`)
};

const it_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialista marketing`)
};

const nl_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketingspecialist`)
};

const pl_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specjalista ds. marketingu`)
};

const fi_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markkinoinnin asiantuntija`)
};

const da_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketingspecialist`)
};

const sv_landing_application_overview_role_3 = /** @type {(inputs: Landing_Application_Overview_Role_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marknadsspecialist`)
};

/**
* | output |
* | --- |
* | "Marketing specialist" |
*
* @param {Landing_Application_Overview_Role_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_role_3 = /** @type {((inputs?: Landing_Application_Overview_Role_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Role_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_role_3(inputs)
	if (locale === "fr") return fr_landing_application_overview_role_3(inputs)
	if (locale === "es") return es_landing_application_overview_role_3(inputs)
	if (locale === "it") return it_landing_application_overview_role_3(inputs)
	if (locale === "nl") return nl_landing_application_overview_role_3(inputs)
	if (locale === "pl") return pl_landing_application_overview_role_3(inputs)
	if (locale === "fi") return fi_landing_application_overview_role_3(inputs)
	if (locale === "da") return da_landing_application_overview_role_3(inputs)
	if (locale === "sv") return sv_landing_application_overview_role_3(inputs)
	return en_landing_application_overview_role_3(inputs)
});